import React from "react";
import { Reveal, SectionHeading } from "@/components/common";
import PhoneMock from "@/components/PhoneMock";
import { HOW_STEPS } from "@/data/content";

const STEP_VARIANTS = ["create", "send", "track", "release"];

export const HowItWorksSection = () => {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="relative py-20 sm:py-28 bg-[#f7faf8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading overline="How it works" title="How Workpay works" center />
        </Reveal>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-14">
          {HOW_STEPS.map((step, i) => (
            <Reveal key={step.n} delay={i * 0.08}>
              <div data-testid={`how-step-${i}`} className="flex flex-col items-center text-center">
                <PhoneMock variant={STEP_VARIANTS[i] || "milestone"} />
                <div className="mt-7 flex items-center justify-center gap-2.5">
                  <span className="h-6 w-6 rounded-full bg-[#091630] text-white text-xs font-bold flex items-center justify-center">
                    {step.n}
                  </span>
                  <h3 className="font-display text-lg font-bold text-[#091630]">{step.title}</h3>
                </div>
                <p className="text-sm text-slate-500 mt-2 leading-relaxed max-w-[240px]">{step.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
